// Instrument Types based on Trading API v1.1.0 specification

export interface Instrument {
  id: string;
  symbol: string;
  name: string;
  assetClass: 'forex' | 'crypto' | 'indices' | 'commodities' | 'synthetic';
  description?: string;
  availableProducts: string[];
  tradingHours?: TradingHours;
  currentPrice?: Price;
  priceHistory?: PriceHistory;
}

export interface Price {
  bid: number;
  ask: number;
  timestamp: string;
  spread?: number;
}

export interface PriceHistory {
  daily: {
    open: number;
    high: number;
    low: number;
    change: number;
    changePercent: number;
  };
}

export interface TradingHours {
  timezone: string;
  sunday: TradingSession[];
  monday: TradingSession[];
  tuesday: TradingSession[];
  wednesday: TradingSession[];
  thursday: TradingSession[];
  friday: TradingSession[];
  saturday: TradingSession[];
}

export interface TradingSession {
  open: string;
  close: string;
}

export interface InstrumentsResponse {
  instruments: Instrument[];
  pagination: {
    currentPage: number;
    totalPages: number;
    totalItems: number;
    itemsPerPage: number;
  };
}

export interface InstrumentPrice {
  instrumentId: string;
  symbol: string;
  bid: number;
  ask: number;
  spread: number;
  timestamp: string;
}

export interface InstrumentFilters {
  product?: string;
  assetClass?: 'forex' | 'crypto' | 'indices' | 'commodities' | 'synthetic';
  status?: 'active' | 'inactive';
  page?: number;
  limit?: number;
}

export interface PriceUpdate {
  instrumentId: string;
  bid: number;
  ask: number;
  timestamp: string;
}

export interface TickData {
  instrumentId: string;
  bid: number;
  ask: number;
  timestamp: string;
}

// UI-specific types for market discovery
export interface MarketInstrument {
  market: string;
  symbol: string;
  name: string;
  price: string;
  change: string;
  instrumentId: string;
  assetClass: string;
  bid: number;
  ask: number;
}

export interface MarketData {
  [key: string]: MarketInstrument[];
}

export type AssetClass = 'forex' | 'crypto' | 'indices' | 'commodities' | 'synthetic';
export type MarketType = 'Forex' | 'Crypto' | 'Indices' | 'Commodities' | 'Synthetic';

export const ASSET_CLASS_MAP: Record<MarketType, AssetClass> = {
  'Forex': 'forex',
  'Crypto': 'crypto', 
  'Indices': 'indices',
  'Commodities': 'commodities',
  'Synthetic': 'synthetic'
};

export const MARKET_TYPE_MAP: Record<AssetClass, MarketType> = {
  'forex': 'Forex',
  'crypto': 'Crypto',
  'indices': 'Indices', 
  'commodities': 'Commodities',
  'synthetic': 'Synthetic'
};
